import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const EmergencyContactsList = ({ sortedAoEnhancedMeasures, assetOwners }) => {
    const intl = useIntl();

    if (!sortedAoEnhancedMeasures?.length) {
        return null;
    }

    return (
        <div className="govuk-body govuk-!-margin-top-4">
            {sortedAoEnhancedMeasures.map((measure, index) => {
                // Find the owner in assetsInAOIOwners by matching dataProviderId
                const owner = assetOwners?.assetsInAOIOwners?.find(
                    ao => ao.dataProviderId === measure.dataProviderId
                );
                const emergencyContacts = owner?.contacts?.emergency || [];

                if (!emergencyContacts.length) {
                    return null;
                }

                return (
                    <div key={measure.displayName ?? index} className="govuk-!-margin-bottom-4">
                        <p className="govuk-body govuk-!-font-weight-bold govuk-!-margin-bottom-1">
                            {measure.displayName}
                        </p>
                        <p className="govuk-body govuk-!-margin-bottom-1">
                            {intl.formatMessage({ id: 'viewEnquiryPage.enhancedMeasures.emergencyContact' })}
                        </p>
                        {emergencyContacts.map((contact, contactIndex) => {
                            const phoneNumber = contact.phoneNumber || contact.telephoneNumber || contact.mobileNumber;

                            return (
                                <p key={contactIndex} className="govuk-body govuk-!-margin-bottom-0">
                                    {contact.departmentName && `${contact.departmentName}, `}
                                    {phoneNumber
                                        ? (
                                            <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                                        )
                                        : (
                                            intl.formatMessage({ id: 'viewEnquiryPage.enhancedMeasures.emergencyContact.notAvailable' })
                                        )}
                                </p>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

EmergencyContactsList.propTypes = {
    sortedAoEnhancedMeasures: PropTypes.arrayOf(
        PropTypes.shape({
            displayName: PropTypes.string,
            dataProviderId: PropTypes.string,
            enhancedmeasures: PropTypes.string,
            priority: PropTypes.number
        })
    ),
    assetOwners: PropTypes.shape({
        assetsInAOIOwners: PropTypes.arrayOf(
            PropTypes.shape({
                dataProviderId: PropTypes.string,
                contacts: PropTypes.shape({
                    emergency: PropTypes.arrayOf(
                        PropTypes.shape({
                            phoneNumber: PropTypes.string
                        })
                    )
                })
            })
        )
    })
};

export default EmergencyContactsList;
